import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { StyledEngineProvider } from '@mui/material/styles'
import * as Sentry from '@sentry/react'
import React from 'react'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import App from './App'
import { CustomRouter } from './components/common/CustomRouter'
import Loader from './components/common/Loader'
import './index.css'
import store from './redux/store'
// import * as serviceWorker from './serviceWorker'
import theme from './theme'

try {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
  console.log('Sentry initialized successfully');
  (window as any).Sentry = Sentry
} catch (error) {
  console.error('Failed to initialize Sentry:', error)
}


ReactDOM.render(
  <React.Suspense fallback={<Loader />}>
    <CookiesProvider>
      <Provider store={store}>
        <StyledEngineProvider injectFirst={true}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ToastContainer limit={0} position={'top-right'} hideProgressBar={true} autoClose={2000} />
            <Sentry.ErrorBoundary
              fallback={({ error }) => (
                <div className="error-boundary">
                  <h2>An error has occurred</h2>
                  <p>{error?.toString() || 'Unknown error'}</p>
                  <button onClick={() => window.location.reload()}>Refresh the page</button>
                </div>
              )}
            >
              <CustomRouter>
                <App />
              </CustomRouter>
            </Sentry.ErrorBoundary>
          </ThemeProvider>
        </StyledEngineProvider>
      </Provider>
    </CookiesProvider>
  </React.Suspense>,
  document.getElementById('root')
)
// serviceWorker.unregister()
